// src/rds_ui/api/documentsApi.js
//
// Section metadata for the controlled Jade documents, served by the backend
// (SPEC-07 D-7). The studio used to carry its own hardcoded copy of the section
// list, which meant a template gaining or renaming a section needed a frontend
// deploy to match. It reads that list from here instead.
import { api } from "../../api/client";

const BASE = "/rds";

/**
 * The document types RDS knows about, and whether each is ready to generate.
 * `available` is false for a type that is specified but not built yet.
 */
export async function fetchDocumentTypes() {
  try {
    const res = await api.get(`${BASE}/documents`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch document types");
  }
}

/**
 * Section metadata for one document type: key, title, template section number,
 * kind ("prose" | "table" | "diagram"), the column list for tables, and the
 * template's own guidance for what belongs in the section.
 */
export async function fetchDocumentSections(documentType) {
  try {
    const res = await api.get(`${BASE}/documents/${documentType}/sections`);
    return res.data;
  } catch {
    throw new Error(`Failed to fetch sections for ${documentType}`);
  }
}
